import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface Properties2 {}

export interface CutAndSewRugCustomerInfoParameter extends ApiParameter {
    PONumber?: string;
    STCompanyName?: string;
    STStreet1?: string;
    STStreet2?: string;
    STStreet3?: string;
    STCity?: string;
    STCountry?: string;
    STState?: string;
    STPostalCode?: string;
    Sidemark?: string;
    TypeOfCustomRequest?: string;
    FormOfDeposit?: string;
    CheckNumber?: string;
    FullName?: string;
    Title?: string;
    Email?: string;
    Signature?: string;
    Date?: string;
    CutAndSewRugsOrderDetailsList?: CutAndSewRugsOrderDetailsList[];
}

export interface CutAndSewRugsOrderDetailsList {
    Quantity?: number;
    Item?: string;
    Size?: string;
    Shape?: string;
    Price?: string;
    TotalPrice?: string;
}

export interface CreditDataResultModel {}

const CreateAccountUrl = "/api/v2/cutandsewrugform";

export async function cutAndSewRugCustomerInfo(parameter: CutAndSewRugCustomerInfoParameter) {
    const response = await post<CreditDataResultModel>(CreateAccountUrl, parameter);
    return response;
}
